import styled, {css} from 'styled-components';

import MoreSvg from '../../../../assets/icons/more.svg';
import ProfileSvg from '../../../../assets/icons/primary/Profile.svg';
import CalendarSvg from '../../../../assets/icons/secondary/Calendar.svg';
import {getColor, getRem, ms, square} from '../../../../styles';
import {Button} from '../../../../uikit/Button';
import {Clickable} from '../../../../uikit/Clickable';
import {Image} from '../../../../uikit/Image';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';
import {platform} from '../../../../utils/platform';

export const Wrapper = styled(View)`
  flex-direction: column;
  padding: ${ms(12)} ${ms(16)};
  border-radius: ${ms(12)};
  background-color: ${getColor('background1')};

  ${() =>
    platform.isNative &&
    css`
      border: 1px solid ${getColor('border1')};
      margin-inline: ${ms(20)};
      margin-block-start: ${ms(12)};
    `}
`;

export const Container = styled(View)`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${ms(12)};
`;

export const ContentWrapper = styled(View)`
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  gap: ${ms(12)};
  flex: 1;
`;

export const Content = styled(View)`
  flex: 1;
  flex-direction: column;

  ${platform.isNative &&
  css`
    row-gap: ${ms(4)};
  `}
`;

export const Avatar = styled(Image)`
  ${square(40)};
  border-radius: ${ms(20)};
`;

export const Name = styled(Text).attrs({
  nativeProps: {
    numberOfLines: 1,
  },
  weight: 'semibold',
})`
  font-size: ${getRem(15)};
  line-height: ${getRem(20)};
  letter-spacing: ${getRem(-0.24)};
`;

export const Label = styled(Text).attrs({
  nativeProps: {adjustsFontSizeToFit: true, numberOfLines: 1},
})`
  font-size: ${ms(13)};
  line-height: ${ms(18)};
  letter-spacing: ${ms(-0.24)};
  color: ${getColor('text3')};
`;

export const ButtonsContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  gap: ${ms(12)};
`;

export const ResendButton = styled(Button).attrs({scheme: 'gray'})``;

export const ResendButtonText = styled(Text).attrs({weight: 'semibold'})`
  font-size: ${getRem(14)};
  line-height: ${getRem(24)};
  letter-spacing: ${getRem(-0.24)};
  color: ${getColor('text3')};
`;

export const CancelButton = styled(ResendButton)``;

export const CancelButtonText = styled(ResendButtonText)`
  color: ${getColor('error')};
`;

const SMoreIcon = styled(MoreSvg).attrs(p => ({
  fill: getColor('icon3')(p),
}))`
  ${square(24)};
`;

export {SMoreIcon as MoreIcon};

export const MoreIconClickable = styled(Clickable).attrs({
  hitSlop: {
    bottom: 5,
    left: 10,
    right: 10,
    top: 5,
  },
})``;

export const MessageContainer = styled(View)`
  padding-block-start: ${ms(12)};
  margin-block-start: ${ms(12)};
  border-top: 1px solid ${getColor('border1')};
`;

export const Message = styled(Text)`
  font-size: ${getRem(14)};
  line-height: ${getRem(24)};
  letter-spacing: ${getRem(-0.46)};
`;

export const EmailAvatarPlaceholder = styled(View)`
  flex: 1;
  align-items: center;
  justify-content: center;
  background-color: ${getColor('background2')};
`;

export const EmailAvatarPlaceholderIcon = styled(ProfileSvg).attrs(p => ({
  fill: getColor('icon3')(p),
}))`
  ${square(24)};
`;

export const CourseDatesContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  gap: ${ms(platform.isNative ? 4 : 8)};
  flex: 1.5;
`;

export const CalendarIcon = styled(CalendarSvg).attrs(p => ({
  fill: getColor('icon3')(p),
}))`
  ${square(platform.isNative ? 16 : 20)};
`;

export const CourseLabel = styled(Text).attrs({
  weight: platform.isWeb ? 'semibold' : 'regular',
})`
  font-size: ${getRem(12)};
  line-height: ${getRem(16)};
  letter-spacing: ${getRem(-0.24)};

  ${platform.isWeb &&
  css`
    font-size: ${getRem(14)};
    line-height: ${getRem(24)};
  `}
`;
